/** Hand the person a text file to save (the browser's download), from text built here. */
export function saveTextFile(
  fileName: string,
  text: string,
  type = 'text/csv;charset=utf-8'
): void {
  // A byte-order mark so Excel reads the CSV as UTF-8 (names with accents, the en dashes in place names).
  const url = URL.createObjectURL(new Blob(['\ufeff', text], { type }));
  const link = document.createElement('a');
  link.href = url;
  link.download = fileName;
  link.click();
  // Freed later, not at once: Safari (iPad) can still be reading the file when click() returns. Only memory is at stake.
  setTimeout(() => URL.revokeObjectURL(url), 60_000);
}
